"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _KEDCOTT4cjs = require('./KEDCOTT4.cjs');





var _EV33XSIBcjs = require('./EV33XSIB.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');






var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/combobox/combobox-list.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useComboboxList = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useComboboxList2({ store, alwaysVisible, ...props }) {
    const scopedContext = _EV33XSIBcjs.useComboboxScopedContext.call(void 0, true);
    const context = _EV33XSIBcjs.useComboboxContext.call(void 0, );
    store = store || context;
    const scopedContextSameStore = !!store && store === scopedContext;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component."
    );
    const ref = _react.useRef.call(void 0, null);
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const mounted = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "mounted");
    const hidden = _KEDCOTT4cjs.isHidden.call(void 0, mounted, props.hidden, alwaysVisible);
    const style = hidden ? { ...props.style, display: "none" } : props.style;
    const multiSelectable = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => Array.isArray(state.selectedValue)
    );
    const role = _3BSDKDKDcjs.useAttribute.call(void 0, ref, "role", props.role);
    const isCompositeRole = role === "listbox" || role === "tree" || role === "grid";
    const ariaMultiSelectable = isCompositeRole ? multiSelectable || void 0 : void 0;
    const [hasListboxInside, setHasListboxInside] = _react.useState.call(void 0, false);
    const contentElement = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "contentElement");
    _3BSDKDKDcjs.useSafeLayoutEffect.call(void 0, () => {
      if (!mounted) return;
      const element = ref.current;
      if (!element) return;
      if (contentElement !== element) return;
      const callback = () => {
        setHasListboxInside(!!element.querySelector("[role='listbox']"));
      };
      const observer = new MutationObserver(callback);
      observer.observe(element, {
        subtree: true,
        childList: true,
        attributeFilter: ["role"]
      });
      callback();
      return () => observer.disconnect();
    }, [mounted, contentElement]);
    if (!hasListboxInside) {
      props = {
        role: "listbox",
        "aria-multiselectable": ariaMultiSelectable,
        ...props
      };
    }
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _EV33XSIBcjs.ComboboxScopedContextProvider, { value: store, children: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _EV33XSIBcjs.ComboboxListRoleContext.Provider, { value: role, children: element }) }),
      [store, role]
    );
    const setContentElement = id && (!scopedContext || !scopedContextSameStore) ? store.setContentElement : null;
    props = {
      hidden,
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, setContentElement, ref, props.ref),
      style
    };
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var ComboboxList = _PTOCUU2Dcjs.forwardRef.call(void 0, function ComboboxList2(props) {
  const htmlProps = useComboboxList(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useComboboxList = useComboboxList; exports.ComboboxList = ComboboxList;
